import { FormattedMessage as FM } from "react-intl";

/**
 *
 * @param {*} props -
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component TextField
 */

function SelectionCell({ data, field }) {
  let _value;
  if (typeof data.value === "string") {
    _value = data.value;
  } else {
    _value = data ? data.value?.id : null;
  }

  for (const option of field.options) {
    if (option.id === _value) {
      _value = option.name;
      break;
    }
  }

  if (field.translate && _value && _value !== "") {
    _value = <FM id={_value} key={_value} />;
  }

  function onChange(event) {
    console.log("Not implemented update in SelectionCell!");
  }

  return _value;
}

export default SelectionCell;
